"use client";
import React, { useContext, useEffect } from "react";

import { hubspotForms as hubspotDefaultConfig } from "@stadium/constants";
import { HubspotContext } from "@stadium/services/hubspot/provider";

const HubspotForm = ({ formId, classes = "" }) => {
  const { hubspotObj, initHubspot } = useContext(HubspotContext);

  useEffect(() => {
    initHubspot();
  }, []);

  useEffect(() => {
    if (typeof hubspotObj === "object" && formId && hubspotDefaultConfig.portalId) {
      hubspotObj.forms?.create({
        ...hubspotDefaultConfig,
        formId,
        target: `[data-behaviour='${formId}']`,
      });
    }
  }, [formId, hubspotObj]);
  return <div className={classes} data-behaviour={formId} />;
};

export default HubspotForm;
